import React, { useEffect, useState } from "react";
import gif from '../assets/images/thunder.gif';
import grd1 from '../assets/images/jsbaidwan_curly_haired_batwomen_without_mask_running_marathon_i_df6a077f-7473-49d7-86b1-b00e110bec05_ins.webp';
import grd2 from '../assets/images/image-2.webp';
import grd3 from '../assets/images/image-3.webp';
import grd4 from '../assets/images/image-4.webp';
import flash from '../assets/images/flash-sale.png';
import confeti from '../assets/images/confetti (2).png';
import peopleproof from '../assets/images/social-proof-people.webp';
import logo from '../assets/images/heylogo.webp';
import influe from '../assets/images/influencergal.webp';
import trendytraveller from '../assets/images/trendy-traveller.png';
import mikebrown from '../assets/images/mike-brown.png';
import emily from '../assets/images/emily-white.png'
import influe2 from '../assets/images/SmallBusinessOwners.webp';
import influe3 from '../assets/images/bottle.webp';
import flyingaarrow from '../assets/images/flying-arrow.webp';
import FAQSection from "./FAQAccordian";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import vidgif from "../assets/images/ailadyvid.mp4";
import { useLocation } from 'react-router-dom';

// import fai1 from '../assets/images/ai-masterpiece.svg';
// import fai2 from '../assets/images/studio-quality.svg';
// import fai3 from '../assets/images/single-payment.svg';
// import fai4 from '../assets/images/one-clickmagic.svg';
// import fai5 from '../assets/images/ai-handle.svg';
// import fai6 from '../assets/images/multiple-industries.svg';
// import art1 from '../assets/images/growtha.svg';
// import art2 from '../assets/images/adlehard.webp';
// import art3 from '../assets/images/Portxchange.svg';
// import art4 from '../assets/images/phaseitup.webp';
// import art5 from '../assets/images/instaclub.webp';
// import art6 from '../assets/images/maea.webp';
// import art7 from '../assets/images/mincrate.webp';
// import brandtrust from '../assets/images/brandpush-trust-badge.webp';
// import visa from '../assets/images/visa.webp';
// import paypel from '../assets/images/paypal.webp';
// import mastercard from '../assets/images/mastercardvs.webp';
// import american from '../assets/images/american-express.webp';
// import discover from '../assets/images/discover.webp';
// import visualenhancement from '../assets/images/visual-enhancement.svg';
// import bgremoval from '../assets/images/bg-removal.svg';
// import scenegeneratio from '../assets/images/scene-generation.svg';
// import unbeatable from '../assets/images/unbeatable-value.svg';
// import speed from '../assets/images/speed-efficiency.svg';
// import total from '../assets/images/total-flexibility.svg';
// import peace from '../assets/images/peaceof-mind.svg';
// const FeatureBox = ({ imgSrc, title }) => (
//     <div className="ft-listbx">
//         <img src={imgSrc} alt="Feature" width="55px" />
//         <h5>{title}</h5>
//     </div>
// );

const Sales = () => {
    const [currentNumber, setCurrentNumber] = useState(4561);
    const [countdown, setCountdown] = useState({
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const increaseNumber = () => {
            const randomIncrease = Math.floor(Math.random() * 3) + 1;
            setCurrentNumber((prev) => prev + randomIncrease);
        };

        const interval = setInterval(increaseNumber, 6000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const getNextExpirationDate = (currentDate) => {
            const nextExpirationDate = new Date(currentDate);
            nextExpirationDate.setHours(24, 0, 0, 0);
            return nextExpirationDate;
        };

        const expirationDate = getNextExpirationDate(new Date());
        const callTime = expirationDate.getTime();

        const timer = setInterval(() => {
            const nowTime = new Date().getTime();
            const distance = callTime - nowTime;
            if (distance > 0) {
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                setCountdown({ hours, minutes, seconds });
            } else {
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const handleClose = () => {
        const banner = document.querySelector(".at-banner");
        if (banner) {
            banner.remove();
        }
        const heroBanner = document.querySelector(".her0banner");
        if (heroBanner) {
            heroBanner.style.paddingTop = "65px";
        }
    };
    const [descriptions, setDescriptions] = useState([]);
    const [descriptionspro, setDescriptionsPro] = useState([]);
    useEffect(() => {
        const handlebasicdetails = async () => {
            try {
                const authData = localStorage.getItem("auth");
                const token = authData ? JSON.parse(authData).token : null;
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/plans-details`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                if (response.data.status === 200) {
                    const descriptionsArray = response.data?.plans?.month?.basic?.descriptions || [];
                    setDescriptions(descriptionsArray);
                    const descriptionsArraypro = response.data?.plans?.month?.pro?.descriptions || [];
                    setDescriptionsPro(descriptionsArraypro);
                }
            } catch (error) {
                console.log('error', error)
            }
        }

        handlebasicdetails();
    }, []);
    const navigate = useNavigate();

    const encodeBase64 = (str) => {
        return btoa(unescape(encodeURIComponent(str)));
    };
    const encryptId = (id) => {
        return encodeBase64(JSON.stringify(id));
    };

    const handlebasic = async () => {
        var localurl = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

        if (localurl) {
            var details = {
                id: 'price_1OKbB6SGRr4w2BKKZRiYQWo4',
                plan: 'Basic',
                originalPrice: '$20.00',
                originalTimeperiod: '/month',
                discountedPrice: '$10.00',
                discountedTimeperiod: '/month',
                description: 'Amazing Powerpack For Influencers',
            };
        } else {
            var details = {
                id: 'price_1OitMuSGRr4w2BKKbKMhMNfo',
                plan: 'Basic',
                originalPrice: '$18.00',
                originalTimeperiod: '/month',
                discountedPrice: '$9.00',
                discountedTimeperiod: '/month',
                description: 'Amazing Powerpack For Influencers',
            };
        }




        const encryptedId = encryptId(details);
        const authData = localStorage.getItem('auth');

        if (authData) {
            // Parse the authentication data
            const { id: userAid } = JSON.parse(authData);

            // Remove authentication data
            localStorage.removeItem('auth');

            // Remove the user's profile image if it exists
            if (userAid) {
                localStorage.removeItem(`profileImage${userAid}`);
            }
        }
        navigate(`/register?checkout=${encryptedId}`, { replace: true });
    };

    const handlepro = async () => {
        var localurl = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

        if (localurl) {
            var details = {
                id: 'price_1OKbBtSGRr4w2BKKVDmjFHrE',
                plan: 'Pro',
                originalPrice: '$30.00',
                originalTimeperiod: '/month',
                discountedPrice: '$15.00',
                discountedTimeperiod: '/month',
                description: 'Ultimate Professional For Business',
            };
        } else {
            var details = {
                id: 'price_1OitN9SGRr4w2BKK4GwxvxYr',
                plan: 'Pro',
                originalPrice: '$38.00',
                originalTimeperiod: '/month',
                discountedPrice: '$19.00',
                discountedTimeperiod: '/month',
                description: 'Ultimate Professional For Business',
            };
        }

        const encryptedId = encryptId(details);
        const authData = localStorage.getItem('auth');

        if (authData) {
            // Parse the authentication data
            const { id: userAid } = JSON.parse(authData);

            // Remove authentication data
            localStorage.removeItem('auth');

            // Remove the user's profile image if it exists
            if (userAid) {
                localStorage.removeItem(`profileImage${userAid}`);
            }
        }
        navigate(`/register?checkout=${encryptedId}`, { replace: true });
    };
    const location = useLocation();
    // useEffect(() => {
    //     const cssFilesForRoutes = {
    //       '/sales': [
    //         './assests2/css/bootstrap2.min.css',
    //         './assests2/css/style3.css',
    //         './assests2/css/media.css',
    //         './assests2/css/fonts.css',
    //         './assests2/css/animate.css',
    //         './assests2/css/style.bundle2.css',
    //         './assests2/css/style2.css',
    //       ],
    //     };
    
    //     const addCSS = (files) => {
    //       files.forEach((href) => {
    //         if (!document.querySelector(`link[href="${href}"]`)) {
    //           const link = document.createElement('link');
    //           link.rel = 'stylesheet';
    //           link.href = href;
    //           link.classList.add('sales-dynamic-css');
    //            link.onload = () => console.log(`Loaded: ${href}`);
    //           document.head.appendChild(link);
    //         }
    //       });
    //     };
    
    //     const removeCSS = () => {
    //       const dynamicLinks = document.querySelectorAll('.sales-dynamic-css');
    //       dynamicLinks.forEach((link) => {
    //         link.remove();
    //       });
    //     };
    
    //     const cssFiles = cssFilesForRoutes[location.pathname];
    //     if (cssFiles) {
    //       addCSS(cssFiles);
    //     }
    
    //     return () => {
    //       removeCSS();
    //     };
    //   }, [location.pathname]);

    return (
        <>
            {/* banner  */}
            <div className="at-banner">
                <div className="at-banner__content">
                    <div className="mobile-row">
                        <div className="at-banner__text">
                            <div className="title">
                                <span style={{ fontWeight: 700 }}>
                                    FLASH <span style={{ color: "red" }}>SALE</span>
                                </span>
                                <img src={flash} alt="Flash Sale" width="40px" />
                            </div>
                        </div>

                        <span className="d-none d-md-block" style={{ fontSize: "24px" }}>
                            |
                        </span>
                        <span className="disc">
                            Get 50% off{" "}
                            <img src={confeti} alt="Confetti" width="40px" />
                        </span>
                    </div>
                    {/* <div id="dynamic-number">{currentNumber}</div> */}
                    <div className="countdown_timer" id="blackfriday-timer1">
                        <span >{countdown.hours} <small>HRS</small> </span>{" "}
                        <span >{countdown.minutes} <small>MINS</small> </span>{" "}
                        <span >{countdown.seconds} <small>SECS</small> </span>
                    </div>
                   </div>
                <div className="at-banner__close" onClick={handleClose}></div>
            </div>
            {/* main starts  */}
            <div className="commonhero-bg">
                <section className="her0main">
                    <div className="her0banner">
                        <div className="container small">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="her0-inner">
                                        <div className="her0-top">
                                            <span className="banner-vstitle">
                                                #1 MOST TRUSTED AI IMAGE GENERATING TOOLS
                                            </span>
                                            <h1 id="dynamic-heading" className="her0-title wow fadeIn">
                                                SuperCharge <img
                                                    className="thunder-anime"
                                                    src={gif}
                                                    alt="Thunder"
                                                />
                                                your Instagram with AI <br /> Powered <span className="text-linear">High-Converting Visuals</span> in 3 Steps
                                            </h1>
                                            <div className="videoContainer mt-5 mb-10">
                                                <video autoPlay loop muted className="videoResponsive">
                                                    <source
                                                        src={vidgif}
                                                        type="video/mp4"
                                                    />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                            <a className="paddle_button offer-vsbtn paddle_styled_button" href="#choosePlans">
                                                JOIN NOW
                                            </a>
                                        </div>

                                        <div className="container small">

                                            <div className="features-blockbtm">
                                                <div className="gridimg-flx wow fadeIn">
                                                    <div className="gridimg-spacing">
                                                        <img
                                                            className="lazyloaded"
                                                            alt="Grid Image 1"
                                                            src={grd1}
                                                        />
                                                    </div>
                                                    <div className="gridimg-spacing">
                                                        <img
                                                            className="lazyloaded"
                                                            alt="Grid Image 2"
                                                            src={grd2}
                                                        />
                                                    </div>
                                                    <div className="gridimg-spacing">
                                                        <img
                                                            className="lazyloaded"
                                                            alt="Grid Image 3"
                                                            src={grd3}
                                                        />
                                                    </div>
                                                    <div className="gridimg-spacing">
                                                        <img
                                                            className="lazyloaded"
                                                            alt="Grid Image 4"
                                                            src={grd4}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="dynamic-content">
                                            <img
                                                src={peopleproof}
                                                alt="People Social Proof"
                                            />
                                            <div className="dynamic-text">
                                                <span className="title-vsdeco">
                                                    <span id="dynamic-number">{currentNumber} </span> People Can't Be Wrong
                                                </span>
                                                <p>Let AI Generate Breath-taking Visuals for You Today!</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <section className="instant-clientreq">
                <div className="container small">
                    <div className="targetfor-clwidth">
                        <div className="access-vsbox">
                            {/* <h2 className="access-vstitle">Grab CYBER WEEK SALE on Hey Visuals…</h2> */}
                            <h2 className="access-vstitle">Grab FLASH SALE on Hey Visuals…</h2>
                            <p className="access-vsdata">30 days Money Back Guarantee</p>
                            <div className=" mt-4" style={{ textAlign: 'center', }}>
                                <a className="paddle_button offer-vsbtn paddle_styled_button " href="#choosePlans">
                                    JOIN NOW
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="ft-unmatchedmain" id="features">
                <div className="container">
                    <div className="ft-unmatchedouter">
                        <div className="inner-container">
                            <div className="ft-unmatchedinner">
                                <div className="ft-unmatchtpbx">
                                    <div className="unmatched-bigimg">
                                        <h2>FEATURES</h2>
                                    </div>
                                    <h2 className="common-vstitle">
                                        <span
                                            style={{
                                                background: "linear-gradient(90deg, #A7A1FF 18.26%, #EC7DE9 80.31%)",
                                                backgroundClip: "text",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent"
                                            }}
                                        >
                                            HeyVisuals Unmatched Features:
                                        </span>
                                        <br />
                                        <span style={{ color: "#1F2024" }}>
                                            Elevate Your Social Media Like Never Before
                                        </span>
                                    </h2>
                                </div>
                                <div className="ft-unmatch-row">
                                    <div className="unmatchbx-spacing">
                                        <div className="unmatch-box">
                                            <img
                                                src={visualenhancement}
                                                className="lazyloaded"
                                                alt=""
                                            />
                                            <h4 className="ft-unmatchtitle">Faster AI Image Generation</h4>
                                            <p className="ft-unmatchdata">
                                                Creating stunning images is a demand of Instagram to get more visitors and
                                                followers to your account. However, it takes time! With Hey Visuals, it will
                                                take only a few seconds to generate spectacular images.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="unmatchbx-spacing">
                                        <div className="unmatch-box">
                                            <img
                                                src={bgremoval}
                                                className="lazyloaded"
                                                alt=""
                                            />
                                            <h4 className="ft-unmatchtitle">Write Captions In Seconds</h4>
                                            <p className="ft-unmatchdata">
                                                Writing catchy lines and descriptions for the posts may be overwhelming as
                                                it takes your attention to grab people's attention with words. Hey Visuals
                                                has the feature to generate amazing captions in no time for every Instagram
                                                user.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="unmatchbx-spacing">
                                        <div className="unmatch-box">
                                            <img
                                                src={scenegeneratio}
                                                className="lazyloaded"
                                                alt=""
                                            />
                                            <h4 className="ft-unmatchtitle">Make Your Avatar</h4>
                                            <p className="ft-unmatchdata">
                                                The goal of my AI avatar is to bridge the gap between human and machine,
                                                offering a seamless, intuitive experience that feels less like interacting
                                                with software and more like conversing with a helpful, knowledgeable
                                                companion.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="ft-unmatchbtmbx">
                                    <div className="unmatvh-btmdata">
                                        <p className="common-vs-subtitle">
                                            Revolutionize AI for influencers, businesses and celebrities who want to
                                            create content in seconds.
                                        </p>
                                        <p className="common-vs-subtitle">
                                            Whether you're a seasoned expert or a complete beginner, we have everything
                                            you need to create stunning, conversion-boosting product photos
                                        </p>
                                    </div>

                                    <div className="common-offerbanner instant-clientreq wow fadeIn" style={{ visibility: "visible", animationName: "fadeIn" }}>
                                        <h2 className="special-vsprice" style={{ color: "#fff", background: "none", WebkitTextFillColor: "#fff" }}>
                                            Today: Just 50% Discount
                                        </h2>
                                        <a className="paddle_button offer-vsbtn paddle_styled_button" href="#choosePlans">
                                            JOIN NOW
                                        </a>
                                        <div className="payment-flex">
                                            <ul className="card-options">
                                                <li>
                                                    <img
                                                        src={visa}
                                                        className="ls-is-cached lazyloaded"
                                                        alt=""
                                                    />
                                                </li>
                                                <li>
                                                    <img
                                                        src={paypel}
                                                        className="ls-is-cached lazyloaded"
                                                        alt=""
                                                    />
                                                </li>
                                                <li>
                                                    <img
                                                        src={mastercard}
                                                        className="ls-is-cached lazyloaded"
                                                        alt=""
                                                    />
                                                </li>
                                                <li>
                                                    <img
                                                        src={american}
                                                        className="ls-is-cached lazyloaded"
                                                        alt=""
                                                    />
                                                </li>
                                                <li>
                                                    <img
                                                        src={discover}
                                                        className="ls-is-cached lazyloaded"
                                                        alt=""
                                                    />
                                                </li>
                                            </ul>
                                            <div className="gurrantee-offer">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" className="bi bi-shield-lock" viewBox="0 0 16 16">
                                                    <path
                                                        d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"
                                                    />
                                                    <path
                                                        d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415"
                                                    />
                                                </svg>
                                                <span>30 Days Money<br />Back Guarantee</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            {/* tranform  */}
            <section className="comparison-main pt-0">
                <div className="container">
                    <div className="comparison-outer">
                        <div className="comp-tpbox">
                            <img data-src={logo}
                                className="lazyloaded" alt="logo" src={logo} />
                            <h2 className="common-vstitle">
                                Transform Your Social Media Into scroll-stopping
                                <br />
                                <span className="title-vsdeco">10x growth</span> Instagram feeds
                                using Visual Stories
                            </h2>
                            <p className="common-vs-subtitle">
                                Check Out what Hey Visuals can do for your Social Media growth.
                            </p>
                        </div>
                        <div className="vswave">
                            <div className="comparison-inner shadow-sm">
                                <div className="inner-container">
                                    {/* Row 1 */}
                                    <div className="comp-row reverse">
                                        <div className="comp-text-column">
                                            <div className="comp-databx">
                                                {/* <span className="col-vscount">01</span> */}
                                                <h4 className="comp-headtitle">Influencers</h4>
                                                <p className="comp-headata">
                                                    Stand out with engaging content. Whether it's fashion,
                                                    lifestyle, or travel
                                                </p>
                                                <div className="client-vsfeed">
                                                    <p className="compdata-fiff">
                                                        "Hey Visuals has been a key factor in my success -
                                                        my engagement rates have skyrocketed, and brands are
                                                        now reaching out to me for partnerships."
                                                    </p>
                                                    <div className="client-vsbox">
                                                        <div className="clint-img">
                                                            <img
                                                                data-src={trendytraveller}
                                                                className="lazyloaded"
                                                                alt="Influencers logo"
                                                                src={trendytraveller}
                                                            />
                                                        </div>
                                                        <span className="client-vsname">@TrendyTraveller</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="comp-slider-column">
                                            <div
                                                className="comp-comparison-slider wow fadeInLeft"
                                                data-wow-delay="0.2s"
                                                style={{
                                                    visibility: "visible",
                                                    animationDelay: "0.2s",
                                                    animationName: "fadeInLeft",
                                                }}
                                            >
                                                <div className="comp-border">
                                                    <img
                                                        src={influe}
                                                        alt="influencergal"
                                                        style={{ borderRadius: "23px" }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Row 2 */}
                                    <div className="comp-row">
                                        <div className="comp-text-column">
                                            <div className="comp-databx">
                                                {/* <span className="col-vscount">02</span> */}
                                                <h4 className="comp-headtitle">Small Business Owners</h4>
                                                <p className="comp-headata">
                                                    From product shots to promotional material, get visuals
                                                    that resonate with your audience.
                                                </p>
                                                <div className="client-vsfeed">
                                                    <p className="compdata-fiff">
                                                        "After updating our marketing materials with
                                                        HeyVisuals-enhanced images, we noticed a substantial
                                                        increase in foot traffic to our store."
                                                    </p>
                                                    <div className="client-vsbox">
                                                        <div className="clint-img">
                                                            <img
                                                                data-src={mikebrown}
                                                                className="lazyloaded"
                                                                alt=""
                                                                src={mikebrown}
                                                            />
                                                        </div>
                                                        <span className="client-vsname">Mike Brown, Shop Owner</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="comp-slider-column">
                                            <div
                                                className="comp-comparison-slider wow fadeInRight"
                                                data-wow-delay="0.2s"
                                                style={{
                                                    visibility: "visible",
                                                    animationDelay: "0.2s",
                                                    animationName: "fadeInRight",
                                                }}
                                            >
                                                <div className="comp-border">
                                                    <img
                                                        src={influe2}
                                                        alt="SmallBusinessOwners"
                                                        style={{ borderRadius: "23px" }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Row 3 */}
                                    <div className="comp-row reverse">
                                        <div className="comp-text-column">
                                            <div className="comp-databx">
                                                {/* <span className="col-vscount">03</span> */}
                                                <h4 className="comp-headtitle">Photographers</h4>
                                                <p className="comp-headata">
                                                    Expand your creative horizons without spending hours in
                                                    post-production.
                                                </p>
                                                <div className="client-vsfeed">
                                                    <p className="compdata-fiff">
                                                        "HeyVisuals has drastically streamlined my editing
                                                        process, saving me time and allowing me to take on
                                                        additional projects without sacrificing quality."
                                                    </p>
                                                    <div className="client-vsbox">
                                                        <div className="clint-img">
                                                            <img
                                                                data-src={emily}
                                                                className="lazyloaded"
                                                                alt=""
                                                                src={emily}
                                                            />
                                                        </div>
                                                        <span className="client-vsname">Emily White, Professional Photographer</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="comp-slider-column">
                                            <div
                                                className="comp-comparison-slider wow fadeInLeft"
                                                data-wow-delay="0.2s"
                                                style={{
                                                    visibility: "visible",
                                                    animationDelay: "0.2s",
                                                    animationName: "fadeInLeft",
                                                }}>
                                                <div className="comp-border">
                                                    <img
                                                        src={influe3}
                                                        alt="bottle"
                                                        style={{ borderRadius: "23px" }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container">
                <div className="common-offerbanner instant-clientreq wow fadeIn" style={{ visibility: 'visible', animationName: 'fadeIn' }}>
                    <h2
                        className="special-vsprice"
                    >
                        Today: Just 50% Discount
                    </h2>
                    <a className="paddle_button offer-vsbtn paddle_styled_button" href="#choosePlans">
                        JOIN NOW
                    </a>
                </div>
            </div>

            <section className="steps-main">
                <div className="container small">
                    <div className="step-cvouter">
                        <div className="steps-topbx">
                            <div className="steptp-data">
                                <h2 className="common-vstitle">
                                    <span className="title-vsdeco">Simple 3 Steps Process</span> <br /> To
                                    Create Your First AI-powered Content
                                </h2>
                                <p className="common-vs-subtitle">
                                    Say goodbye to expensive and unreliable Social Media Managers!
                                </p>
                            </div>
                        </div>
                        <div className="steps-btmsection row">
                            <div className="steps-rowflex col-md-4 mb-4 md-md-0">
                                <div className="text-md-left">
                                    <span className="count-cvstep">Step 1</span>
                                    <h4 className="inrotxt-brtitle text-linear d-block">Write Your Prompt<br /></h4>
                                    <div className="introtxt-databx">
                                        <p>
                                            Craft a detailed description of your vision. Be as specific as you can! Our AI
                                            thrives on creativity, or turning your words into incredible visuals that match your
                                            imagination.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="steps-rowflex reverse mb-4 md-md-0 col-md-4">
                                <div className="text-md-left">
                                    <span className="count-cvstep pink">Step 2</span>
                                    <h4 className="inrotxt-brtitle text-linear d-block">Click Generate<br /></h4>
                                    <div className="introtxt-databx">
                                        <p>
                                            Hit the "Generate" button to unleash the power of AI. Sit back as we process your
                                            prompt and transform it into a stunning visual creation tailored exactly to your
                                            input.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="steps-rowflex mb-4 md-md-0 col-md-4">
                                <div className="text-md-left">
                                    <span className="count-cvstep">Step 3</span>
                                    <h4 className="inrotxt-brtitle text-linear d-block">Instant Download <br /></h4>
                                    <div className="introtxt-databx">
                                        <p>
                                            Once your masterpiece is ready, download it instantly. No delays, no hassle—just
                                            breathtaking visuals at your fingertips, ready to use for your project,
                                            presentations, or personal inspiration.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* tranfrom section  */}

            <section className="btmvideo-main py-10 mb-5 ">
                <div className="container">
                    <div id="demo" className="btmvideo-wrapper">
                        <div className="btmvideo-tpbox">
                            <h2 className="bmvdo-title">Watch How We Generate </h2>
                            <h3 className="bmvdo-lowtitle">
                                Mind-Blowing Social Media Post in less than 60 seconds.
                            </h3>
                        </div>
                        <div className="hero-vdobtm">
                        <div className="cursive-show">
                            <span>AI Generated images and captions in 60 Seconds</span>
                            </div>
                            <div
                                className="vd-spacing wow fadeIn"
                                style={{ visibility: 'visible', animationName: 'fadeIn' }}
                            >
                                <div className="video-box">
                                    <div className="responsive-video">
                                        <iframe
                                            src="https://fast.wistia.net/embed/iframe/dajig0c7nu?seo=true&videoFoam=true"
                                            allow="autoplay; fullscreen; picture-in-picture"

                                            data-ready="true"
                                        ></iframe>
                                    </div>
                                </div>
                                <div className="text-boxfly">
                                    <span>
                                        AI Generated images and <br /> captions in 60 Seconds
                                    </span>
                                    <img
                                        data-src={flyingaarrow}
                                        className=" ls-is-cached lazyloaded"
                                        alt=""
                                        src={flyingaarrow}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* plans section  */}

            <section className="plans-vsmain" id="choosePlans">
                <div className="plans-inner pt-0">
                    <div className="container">
                        <div className="plans-tpbox">
                            <h2 className="common-vstitle gradient pb-md-5">
                                <span className="title-vsdeco">Hey Visuals Pricing Plans:</span>
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div id="pricing" className="plan-cardrow wow fadeIn justify-content-center" style={{ visibility: "visible", animationName: "fadeIn" }}>
                        {/* Starter Plan */}
                        <div className="plan-spacing">
                            <div className="plan-maincard normal">
                                <div className="plan-cardtopbx">
                                    <h4 className="plan-cardtitle">Hey Visuals - Starter</h4>
                                    <del>$18.00/month</del>
                                    <p className="plan-cardsub">$9.00/month</p>
                                </div>
                                <div className="plan-listbx">
                                    <ul>
                                        {descriptions.map((item, index) => (
                                            <li key={index}>
                                                <span className={`icon ${item.flag}`}></span>
                                                <span dangerouslySetInnerHTML={{ __html: item.message }}></span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="plan-cardbtmbx" id="buy-now">
                                    <div className="plan-buybtn">
                                        <a onClick={handlebasic} style={{ cursor: 'pointer' }} className="paddle_button offer-vsbtn paddle_styled_button" >
                                            BUY NOW
                                        </a>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                        {/* Business Plan */}
                        <div className="plan-spacing">
                            <div className="plan-maincard">
                                <div className="plan-cardtopbx business">
                                    <h4 className="plan-cardtitle">Hey Visuals - Business</h4>
                                    <del>$38.00/month</del>
                                    <p className="plan-cardsub">$19.00/month</p>
                                    {/* <p className="plan-cardsub">Ultimate Professional for Business</p> */}
                                </div>
                                <div className="plan-listbx">
                                    <ul>
                                        {descriptionspro.map((item, index) => (
                                            <li key={index}>
                                                <span className={`icon ${item.flag}`}></span>
                                                <span dangerouslySetInnerHTML={{ __html: item.message }}></span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="plan-cardbtmbx" id="buy-now">
                                    <div className="plan-buybtn">
                                        <a onClick={handlepro} style={{ cursor: 'pointer' }} className="paddle_button offer-vsbtn paddle_styled_button" >
                                            BUY NOW
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Plan Comparison and Footer */}
                        <div className="container">
                            <div className="plan-cardrow footer">
                                {/* Other content can go here */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="reasonsto-main">
                <div className="container">
                    <div className="reasonsto-outer wow fadeIn" style={{ visibility: 'visible', animationName: 'fadeIn' }}>
                        <div className="inner-container">
                            <h2 className="common-vstitle gradient">
                                <span className="title-vsdeco">Why Hey Visuals Professional?</span>
                            </h2>
                            <div className="reasons-flex">
                                <div className="reasons-spacing">
                                    <div className="reasons-vsbox">
                                        <img
                                            data-src={unbeatable}
                                            className="lazyloaded"
                                            alt="unbeatable"
                                            src={unbeatable}
                                        />
                                        <h4 className="reasons-vstitle">Unbeatable Value</h4>
                                        <p className="reasons-vsdata">Get features worth Just $19 Monthly Fees!</p>
                                    </div>
                                </div>
                                <div className="reasons-spacing">
                                    <div className="reasons-vsbox">
                                        <img
                                            data-src={speed}
                                            className="lazyloaded"
                                            alt="speed"
                                            src={speed}
                                        />
                                        <h4 className="reasons-vstitle">Speed & Efficiency</h4>
                                        <p className="reasons-vsdata">Generate thousands of images 10x faster</p>
                                    </div>
                                </div>
                                <div className="reasons-spacing">
                                    <div className="reasons-vsbox">
                                        <img
                                            data-src={total}
                                            className="lazyloaded"
                                            alt="total"
                                            src={total}
                                        />
                                        <h4 className="reasons-vstitle">Total Flexibility</h4>
                                        <p className="reasons-vsdata">No long-term commitments. Cancel anytime.</p>
                                    </div>
                                </div>
                                <div className="reasons-spacing">
                                    <div className="reasons-vsbox">
                                        <img
                                            data-src={peace}
                                            className="lazyloaded"
                                            alt="peace"
                                            src={peace}
                                        />
                                        <h4 className="reasons-vstitle">Peace of Mind</h4>
                                        <p className="reasons-vsdata">30-Day Money-Back Guarantee.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="reasonbtn-center">
                                <a className="paddle_button offer-vsbtn paddle_styled_button" href="#choosePlans">
                                    Get Hey Visual Right Now
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* faqs */}

            <FAQSection />
            {/* main ends  */}
        </>
    );
};

export default Sales;
